<template>
  <div>
    <h3>{{ $t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@PERMANENT_SUBTITLE") }}</h3>
    <p>{{ $tc("ETAB.PAGES.RECRUITMENT.ACTIVATION.@EXPIRATION_IN_DAYS", daysToExpiration) }}</p>

    <QList class="text-left">
      <!-- Qualification -->
      <QItem>
        <QItemSection avatar>
          <QIcon name="icon-f-user" />
        </QItemSection>
        <QItemSection>
          <QItemLabel>
            <b v-if="recruitment.isCDI()">{{ $t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@DEMAND_CDI") }}</b>
            <b v-if="recruitment.isSeason()">{{ $t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@DEMAND_SEASON") }}</b>
          </QItemLabel>
          <QItemLabel caption>
            {{ recruitment.getQualificationLabel() }}
          </QItemLabel>
        </QItemSection>

        <QItemSection :class="hasActiveSubscription ? 'q-mt-md' : ''" side>
          <QItemLabel :class="hasActiveSubscription ? 'text-strike' : ''">
            <b>{{ $t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@PRICE_TTC", { price: demandRecap.getPriceTTC() }) }}</b>
          </QItemLabel>
          <QItemLabel v-if="hasActiveSubscription" class="text-italic" caption>
            {{ $t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@SUBSCRIPTION_ACTIVE") }}
          </QItemLabel>
        </QItemSection>
      </QItem>

      <QSeparator inset />

      <!-- Credit -->
      <template v-if="!hasActiveSubscription && canUseCredit">
        <QItem>
          <QItemSection avatar>
            <QIcon name="icon-f-heart" />
          </QItemSection>
          <QItemSection>
            <QItemLabel>
              <b>{{ $t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@CREDIT") }}</b>
            </QItemLabel>
          </QItemSection>

          <QItemSection side>
            <QItemLabel>
              <b>{{ $t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@PRICE_TTC", { price: demandRecap.getCredit() }) }}</b>
            </QItemLabel>
          </QItemSection>
        </QItem>

        <QSeparator />
      </template>

      <!-- Total -->
      <QItem>
        <QItemSection avatar>
          <QIcon color="secondary" name="icon-f-file-text" />
        </QItemSection>
        <QItemSection class="text-secondary">
          <QItemLabel>
            <b>{{ $filters.whitespacedPunctuation($t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@TOTAL")) }}</b>
          </QItemLabel>
        </QItemSection>

        <QItemSection side class="text-secondary">
          <QItemLabel>
            <b v-if="shouldPay">{{ $t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@PRICE_HT", { price: demandRecap.getPriceHT() }) }}</b>
            <b v-else>{{ $t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@PRICE_ZERO") }}</b>
          </QItemLabel>
        </QItemSection>
      </QItem>
      <QItem v-if="hasActiveSubscription">
        <p class="asterisk">
          {{ $t("ETAB.PAGES.RECRUITMENT.ACTIVATION.@ASTERISK") }}
        </p>
      </QItem>
    </QList>
  </div>
</template>

<script>
  import { DemandRecapModel, RecruitmentPermanentModel } from "@core/models";

  export default {
    props: {
      hasActiveSubscription: {
        type: Boolean,
        default: false,
      },
      demandRecap: {
        type: Object,
        default: () => new DemandRecapModel(),
      },
      recruitment: {
        type: Object,
        default: () => new RecruitmentPermanentModel(),
      },
    },
    computed: {
      canUseCredit() {
        return this.demandRecap.canUseCredit();
      },
      shouldPay() {
        return !this.hasActiveSubscription && !this.canUseCredit;
      },
      daysToExpiration() {
        const secondsToExpiration = this.recruitment.getSecondsToExpiration();
        return Math.floor(secondsToExpiration / 3600 / 24);
      },
    },
  };
</script>
